export const Dashboard = () => import('./Dashboard').then(({ Dashboard }) => {
  return {
    Component: Dashboard
  };
});
